export class LocaleHelper {
  /**
   * Get the locale formatter for a given country.
   * @param countryCode The ISO 3166-1 alpha-2 country code (e.g., "US", "CA").
   * @returns An Intl.NumberFormat instance for the specified country.
   */
  public static getCurrencyFormatter(countryCode: string): Intl.NumberFormat {
    switch (countryCode.toUpperCase()) {
      case "US": // United States
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      case "CA": // Canada
        return new Intl.NumberFormat("en-CA", {
          style: "currency",
          currency: "CAD",
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      case "GB": // United Kingdom
        return new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      case "EU": // Eurozone
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      case "JP": // Japan
        return new Intl.NumberFormat("ja-JP", {
          style: "currency",
          currency: "JPY",
          useGrouping: true,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      default:
        throw new Error(`Unsupported country code: ${countryCode}`);
    }
  }

  /**
   * Returns the currency symbol for the given country code.
   * Example: US -> $, CA -> $, GB -> £, EU -> €, JP -> ¥
   */
  public static getCurrencySymbol(countryCode: string): string {
    const formatter = this.getCurrencyFormatter(countryCode);

    const parts = formatter.formatToParts(0);

    return parts.find((part) => part.type === "currency")?.value ?? "$";
  }
}
